export default __webpack_public_path__ + "static/media/fragrnace-inner-img1.ca72e3a5.png";